export class Config {
    public title: string;
    public updateLabel: string;
    public createLabel: string;
    public deleteLabel: string;
    public cancelLabel: string;

    constructor(title: string) {
        this.title = title;
        this.updateLabel = 'SAVE';
        this.createLabel = 'CREATE';
        this.deleteLabel = 'DELETE';
        this.cancelLabel = 'CANCEL';
    }
}



// WEBPACK FOOTER //
// ./src/models/crud/Config.ts